import request from "../utils/request";
import setting from "./apiSetting";
var type = "Archive";
var urls = 'http://' + setting.getip() + ":" + setting.getport() + "/api/" + type;
var myfunction = {
  getFileURl: function getFileURl(data) {
    return urls + "/View?id=" + data;
  },
  getUploadFileURL: function getUploadFileURL() {
    return urls + "?format=jpeg";
  },
  delectFile: function delectFile(id) {
    var data = {
      id: id
    };
    return request({
      url: urls + "/Delete",
      method: 'post',
      data: data
    });
  },
  uploadFile: function uploadFile(format, data) {
    var params = {
      format: format
    };
    return request({
      url: urls,
      method: 'post',
      params: params,
      data: data
    });
  },
  downloadFile: function downloadFile(id) {
    return urls + "/Download?id=" + id; // request({
    // 	url: urls + "/Download",
    // 	method: 'get',
    // 	params: params,
    // 	responseType: 'blob'
    // }).then(response => {
    // 	this.download(response)
    // }).catch((error) => {
    // })
  }
};
export default myfunction;